import reportActions from "../actions/reportCampaignAction";
import eventAdvertise from "../actions/eventAdvertise";
import helpersTime from "../../helpers/time";
import typeCampaignCategorySelected from "../../component/sections/report/TypeCampaignCategorySelected";
import constantsReportCampaign from "../../component/sections/report/constants/reportCampaign";
import activeChart from "../actions/activeChart";
import separationActive from "../../component/sections/report/SeparationActive";
import moment from "moment";

const mainState = {
  which_type_select: constantsReportCampaign.whichTypeSelect.TYPE_CAMPAIGNS,
  campaign_type_category_selected: typeCampaignCategorySelected.ALL,
  campaign_id_selected: 0,

  count_active_campaign: 0,
  count_active_advertise: 0,
  status_campaign: 0,
  count_click: 0,
  count_view: 0,
  time_view_campaign: 0,

  which_separation_active: separationActive.CAMPAIGN,

  date_from: helpersTime.addStartTime(helpersTime.getLastDayDate(1)),
  date_to: helpersTime.addStartTime(moment().format("YYYY-MM-DD")),
  active_chart: activeChart.LINE_SIMPLE,

  event_data_chart: eventAdvertise.eventAdvertiseString.VIEW,

  data_chart: [],
  data_chart_separation: {},

  browsers_cities: {},
  browsers_OS: {},
  browsers_type: {},
  total_view: 0,

  browsers_ip: {},

  is_get_data_browser_type_from_api: 0,
  is_get_data_browser_cities_from_api: 0,

  price: 0,
};
const main = (state = mainState, action) => {
  let newState = state;

  switch (action.type) {
    case reportActions.GET_REPORT_CAMPAIGN_SUCCESS:
      newState = {
        ...state,
        status_campaign: action.payload.status_campaign,
        count_active_advertise: action.payload.count_active_advertise,
        count_click: action.payload.count_click_campaign,
        count_view: action.payload.count_view_campaign,
        time_view_campaign: Math.floor(action.payload.time_view_campaign / 60),
        price: action.payload.cost_campaign,
        campaign_id_selected: action.payload.campaignID,
        which_type_select: constantsReportCampaign.whichTypeSelect.CAMPAIGN,
      };
      break;

    case reportActions.GET_REPORT_CAMPAIGN_FAILED:
      alert("گرفتن گزارش با مشکل روبرو شد");
      break;

    case reportActions.SET_DATE_REPORT_FILTER:
      newState = {
        ...state,
        date_from: action.payload.date_from,
        date_to: action.payload.date_to,
      };
      break;

    case reportActions.GET_CAMPAIGNS_REPORT_SUCCESS:
      newState = {
        ...state,
        count_active_campaign:
          action.payload.reportCampaigns.count_active_campaign,
        count_click: action.payload.reportCampaigns.count_click_campaign,
        count_view: action.payload.reportCampaigns.count_view_campaign,
        time_view_campaign: Math.floor(
          action.payload.reportCampaigns.time_view_campaign / 60
        ),
        price: action.payload.reportCampaigns.cost_campaign,
        campaign_type_category_selected: action.payload.campaign_type,
        which_type_select:
          constantsReportCampaign.whichTypeSelect.TYPE_CAMPAIGNS,
      };
      break;

    case reportActions.GET_CAMPAIGNS_REPORT_FAILED:
      break;

    case reportActions.GET_DATA_CHART_SUCCESS:
      newState = {
        ...state,
        date_from: action.payload.date_from,
        date_to: action.payload.date_to,
        data_chart: action.payload.data_chart,
        active_chart:
          helpersTime.getDifferentDates(
            action.payload.date_from,
            action.payload.date_to
          ) == 1
            ? activeChart.LINE_SIMPLE
            : activeChart.BAR,
      };
      break;

    case reportActions.SET_EVENT_DATA_CHART:
      newState = {
        ...state,
        event_data_chart: action.payload.event_data_chart,
      };
      break;

    case reportActions.SET_TYPE_SEPARATION_DATA_CHART:
      newState = {
        ...state,
        which_separation_active: action.payload.separation,
      };
      break;

    case reportActions.GET_CAMPAIGNS_DATA_SEPARATION_SUCCESS:
      newState = {
        ...state,
        date_from: action.payload.date_from,
        date_to: action.payload.date_to,
        data_chart_separation: action.payload.data_chart_separation,
      };
      break;

    case reportActions.GET_CAMPAIGN_REPORT_BROWSER_SUCCESS:
      newState = {
        ...state,
        browsers_OS: action.payload.browsers_OS,
        browsers_type: action.payload.browsers_type,
        is_get_data_browser_type_from_api: 1,
      };
      break;

    case reportActions.GET_CAMPAIGNS_REPORT_BROWSER_SUCCESS:
      newState = {
        ...state,
        browsers_OS: action.payload.browsers_OS,
        browsers_type: action.payload.browsers_type,
        is_get_data_browser_type_from_api: 1,
      };
      break;

    case reportActions.EMPTY_CAMPAIGNS_DATA_SEPARATION_FAILED:
      newState = {
        ...state,
        data_chart_separation: {},
      };
      break;

    case reportActions.GET_CAMPAIGN_REPORT_BROWSER_CITIES_SUCCESS:
      newState = {
        ...state,
        browsers_cities: action.payload.data,
        is_get_data_browser_cities_from_api: 1,
      };
      break;

    case reportActions.GET_CAMPAIGNS_REPORT_BROWSER_CITIES_SUCCESS:
      newState = {
        ...state,
        browsers_cities: action.payload.data,
        is_get_data_browser_cities_from_api: 1,
      };
      break;

    case reportActions.GET_CAMPAIGN_REPORT_BROWSER_IP_SUCCESS:
      newState = {
        ...state,
        browsers_ip: action.payload.data,
      };
      break;

    case reportActions.GET_CAMPAIGNS_REPORT_BROWSER_IP_SUCCESS:
      newState = {
        ...state,
        browsers_ip: action.payload.data,
      };
      break;

    case reportActions.GET_CAMPAIGNS_REPORT_BROWSER_IP_FAILED:
      newState = {
        ...state,
        browsers_ip: {},
      };
      break;

    case reportActions.GET_CAMPAIGN_REPORT_BROWSER_IP_FAILED:
      newState = {
        ...state,
        browsers_ip: {},
      };
      break;

    case reportActions.RESET_IS_GET_DATA_BROWSER_FROM_API:
      newState = {
        ...state,
        is_get_data_browser_type_from_api: 0,
        is_get_data_browser_cities_from_api: 0,
      };
      break;
  }
  return newState;
};
export default main;
